import { runtimeConfig } from '@/const/env';

export const useIsVibeBuilderEnabled = (): boolean => {
    return Boolean(runtimeConfig.vibeBuilderRemoteUrl);
};
